import { Outlet } from 'react-router-dom';
import styles from './AuthLayout.module.css';

export default function AuthLayout() {
  return (
    <div className={styles.root}>
      <div className={styles.panel}>
        <div className={styles.logo}>
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-label="Weekend Game">
            <rect width="40" height="40" rx="10" fill="var(--color-primary)" />
            <text x="20" y="27" textAnchor="middle" fill="white" fontSize="20" fontWeight="700">G</text>
          </svg>
          <span className={styles.logoText}>Weekend Game</span>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
